import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Form } from 'reactstrap'
import { translate } from 'react-i18next'

import AuthActions from 'store/redux/auth'
import { pageData } from 'decorators'
import { FG, Button } from 'components'
import './Auth.css'

@connect(
    state => ({
        isLoading: state.global.loading,
        // initialValues: {
        //     username: 'superadmin',
        //     password: 'secret'
        // }
    }),
    {
        signin: AuthActions.signin,
        signout: AuthActions.signout
    }
)
@translate()
@pageData({ title: 'Master of ceremonies login' })
@reduxForm({ form: 'ceremoniesMasterLogin' })
export class SuperAdminSignin extends Component {
    componentWillMount() {
        this.props.signout(false)
    }
    onSubmit = ({ username, password }) => this.props.signin({ type: 'superadmin', username, password })

    render() {
        const { handleSubmit, invalid, submitting, t, isLoading } = this.props

        return (
            <div className="Auth darkmode-background">
                <div className="Auth__Container">
                    <div className="d-flex justify-content-center">
                        <h1 dangerouslySetInnerHTML={{ __html: t('auth.superadmin.title') }} />
                    </div>
                    <Form onSubmit={handleSubmit(this.onSubmit)} autoComplete="off">
                        <FG.Text id="username" name="username" label={t('auth.superadmin.input.username')} required autoComplete="off" />
                        <FG.Text id="password" name="password" type="password" label={t('auth.superadmin.input.password')} required autoComplete="new-password" />

                        <div className="d-flex justify-content-center">
                            <Button type="submit" color="primary" loading={isLoading} disabled={invalid || submitting}>
                                {t('auth.superadmin.btn')}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/SuperAdmin/Auth/SuperAdminSignin.js